export default __webpack_public_path__ + "0ad15edac9ed29a9f1939930ac7e047e.png";